import React from "react";
import Functions from "../../Common/Functions";
import ShopDownloadStats from "../../Common/ShopDownloadStats";
import MARKER_PERMISSIONS from "../../../permissions/Markers.json";
import { havePermission } from "../../../permissions";
import { Constant } from "../../Common";

const { variables, defaultFilters } = Constant;
const { bat_contracted_outlets } = variables;
const { getTenantName, getCensusNameMapping } = Functions;
export const DownloadMarkersButtonLayer = ({
	tenant,
	selecteddropDown,
	currentSelectedTypeIndex,
	shopCounts,

	keyNameMapping,
	shopsStructure,
	apiTracking,
	dispatch,
	areasMapping,
	selectedType,
	currentPolygonsSelectedType
}) => {
	return (
		<div className="d-flex fex-row ">
			{havePermission(MARKER_PERMISSIONS.MARKER_CENSUS_DOWNLOAD) && (
				<ShopDownloadStats
					keyMapping={""}
					buttonLabel={`Load ${getCensusNameMapping(tenant)}`}
					title={`${getCensusNameMapping(tenant)} Info`}
					selecteddropDown={selecteddropDown}
					currentSelectedTypeIndex={currentSelectedTypeIndex}
					shopCounts={shopCounts}
					keyNameMapping={keyNameMapping}
					shopsStructure={shopsStructure}
					apiTracking={apiTracking}
					dispatch={dispatch}
					areasMapping={areasMapping}
					selectedType={selectedType}
					currentPolygonsSelectedType={currentPolygonsSelectedType}
				/>
			)}
			{havePermission(MARKER_PERMISSIONS.MARKER_CLIENT_DOWNLOAD) && (
				<ShopDownloadStats
					keyMapping={"-Client"}
					buttonLabel={`Load ${getTenantName(tenant)}`}
					title={`${getTenantName(tenant)} Info`}
					selecteddropDown={selecteddropDown}
					currentSelectedTypeIndex={currentSelectedTypeIndex}
					shopCounts={shopCounts}
					keyNameMapping={keyNameMapping}
					shopsStructure={shopsStructure}
					apiTracking={apiTracking}
					dispatch={dispatch}
					areasMapping={areasMapping}
					selectedType={selectedType}
					currentPolygonsSelectedType={currentPolygonsSelectedType}
				/>
			)}

			{havePermission(MARKER_PERMISSIONS.TABLE_CLINET_1_SHOPS_COUNT) && (
				<ShopDownloadStats
					keyMapping={`-${bat_contracted_outlets}`}
					buttonLabel={`Load ${bat_contracted_outlets}`}
					title={`${bat_contracted_outlets} Info`}
					selecteddropDown={selecteddropDown}
					currentSelectedTypeIndex={currentSelectedTypeIndex}
					shopCounts={shopCounts}
					keyNameMapping={keyNameMapping}
					shopsStructure={shopsStructure}
					apiTracking={apiTracking}
					dispatch={dispatch}
					areasMapping={areasMapping}
					selectedType={selectedType}
					currentPolygonsSelectedType={currentPolygonsSelectedType}
					extraFilters={defaultFilters[`${tenant}-${variables.bat_contracted_outlets}`] || {}}
				/>
			)}
		</div>
	);
};

export default DownloadMarkersButtonLayer;
